// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs[data-v-1fc2dcf2] {\n  padding-bottom: 16px;\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
